const doc = [({"zh_cn":({"adminConstantHotelQuestionAnswerType":({"radio":"选择(单选按钮)", "selectTag":"选择(下拉)", "text":"自由输入(1行)", "textarea":"自由输入(多行)"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;